import React, { useCallback, useRef, useState } from "react";
import getValidationErrors from "../../../utils/getValidationErrors";
import { FormHandles } from "@unform/core";
import * as Yup from "yup";

import { useToast } from "../../../hooks/toast";
import { useAuth } from "../../../hooks/auth";
import { Form } from "@unform/web";

import ImageUpload from "../../../components/Atoms/ImageUpload";
import Loading from "../../../components/Atoms/Loading";
import Input from "../../../components/Atoms/Input";

import {
  ImageContainer,
  StyledButton,
  PageTitle,
  Container,
  FormFields,
  Field,
  FieldLabel,
  Divider,
  Identity,
  Panel,
  ChildImg,
  MainImg,
} from "./styles";

const UserProfile: React.FC = () => {
  interface DataFormInfo {
    username: string;
    fullname: string;
    email: string;
    password: string;
  }

  const [isUpdating, setIsUpdating] = useState(false);
  const [imgUrl, setImgUrl] = useState("");

  const formRef = useRef<FormHandles>(null);

  const { user, updateUser } = useAuth();
  const { addToast } = useToast();

  const handleUpdate = useCallback(
    async (data: DataFormInfo) => {
      setIsUpdating(true);
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          username: Yup.string().required("Apelido obrigatório!"),
          fullname: Yup.string().required("Nome obrigatório!"),
          email: Yup.string().required("Email obrigatório!"),
          password: Yup.string().required("Senha obrigatória!"),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const updatingUser = user;

        user.email = data.email !== "" ? data.email : user.email;
        user.password = data.password !== "" ? data.password : user.password;
        user.fullname = data.fullname !== "" ? data.fullname : user.fullname;

        await updateUser(updatingUser, imgUrl, true);
        setIsUpdating(false);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
        } else {
          addToast({
            type: "error",
            title: "Erro na edição :(",
            description:
              "Oops... parece que algo deu errado, tente novamente mais tarde!",
          });
        }
        setIsUpdating(false);
      }
    },
    [addToast, imgUrl, updateUser, user]
  );

  return (
    <Container>
      <PageTitle>Perfil</PageTitle>

      <Panel>
        <Identity>
          <ImageContainer>
            <div className="main-profile-img">
              <MainImg
                src={imgUrl && imgUrl !== "" ? imgUrl : user.imageurl}
                alt={`Foto de perfil de ${user.fullname}`}
              />
            </div>
            {user.profileid === "Parent" && (
              <div className="child-profile-img">
                <ChildImg
                  src={
                    imgUrl && imgUrl !== ""
                      ? imgUrl
                      : user.selectedChild?.imageurl
                  }
                  alt={`Foto de perfil de ${
                    user.selectedChild?.fullname ?? "aluno"
                  }`}
                />
              </div>
            )}
          </ImageContainer>

          <ImageUpload setImgUrl={setImgUrl} />
        </Identity>

        <Divider />

        <Form
          ref={formRef}
          onSubmit={handleUpdate}
          style={{ flex: 1, minWidth: 0, width: "100%" }}
        >
          <FormFields>
            <Field>
              <FieldLabel>Nome completo</FieldLabel>
              <Input
                name="fullname"
                enabled={false}
                placeholder="Nome completo"
                defaultValue={user.fullname}
                customBgColor="transparent"
                customWidth="100%"
              />
            </Field>

            <Field>
              <FieldLabel>Apelido</FieldLabel>
              <Input
                enabled={false}
                name="username"
                placeholder="Apelido"
                defaultValue={user.username}
                customBgColor="transparent"
                customWidth="100%"
              />
            </Field>

            <Field>
              <FieldLabel>Sala</FieldLabel>
              <Input
                name="room"
                enabled={false}
                placeholder="Sala"
                defaultValue={user.roomid}
                customBgColor="transparent"
                customWidth="100%"
              />
            </Field>

            <Field>
              <FieldLabel>E-mail</FieldLabel>
              <Input
                name="email"
                placeholder="E-mail"
                defaultValue={user.email}
                customWidth="100%"
              />
            </Field>

            <Field>
              <FieldLabel>Senha</FieldLabel>
              <Input
                name="password"
                type="password"
                placeholder="Senha"
                defaultValue={user.password}
                customWidth="100%"
              />
            </Field>

            <StyledButton type="submit" enabled={!isUpdating}>
              {isUpdating ? <Loading size={2} /> : "SALVAR"}
            </StyledButton>
          </FormFields>
        </Form>
      </Panel>
    </Container>
  );
};

export default UserProfile;
